module.exports = __webpack_public_path__ + "static/aldani-672bec6efea44c62b7b34a7e7be71852.png";